import { tassign } from 'tassign';
import { AdminState, initialAdminState } from './admin-state.model';
import { Action, AdminActions } from './admin-actions';

/**
* @functions AdminReducer Will excecute the according triggered in the dispatcher
* @param state Store model
* @param action The action that will affect the store
* @return tassing<AdminReducer> Value with the store
**/
export const AdminReducer = function (state: AdminState = initialAdminState, action: Action): AdminState {
  switch (action.type) {
    case AdminActions.SET_UPDATE:
      return tassign(state, {
        UpdateType: action.payload.UpdateType,
        updateAttribute: action.payload.updateAttribute,
        updateValue: action.payload.updateValue,
        updatedDate: action.payload.updatedDate,
        otherParams: !!action.payload.otherParams ? action.payload.otherParams : {}
      });
    case AdminActions.RESET_UPDATE:
      return tassign(state, initialAdminState);
    default:
      return state;
  }
};


